'use strict';
import {AwsS3GatewayService} from './AwsS3GatewayService';
import {AwsS3MultiFileService} from './AwsS3MultiFileService';
import {AwsS3RequestService} from './AwsS3RequestService';


const angular = require('angular');

module.exports = angular
  .module('app.core-utilities.aws-api', [
    'AngularFire.util',
    'firebaseMq',
    'eventBus'
  ])
  .constant('FILE_USAGE', require('./FILE_USAGE.js'))
  .factory('AwsS3GatewayService', AwsS3GatewayService)
  .service('AwsS3MultiFileService', AwsS3MultiFileService)
  .service(AwsS3RequestService.SERVICE_NAME, AwsS3RequestService)
;



// WEBPACK FOOTER //
// ./src/js/core-utilities/aws-api/index.js